import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Chip } from '@material-ui/core';
import { BsImageFill } from 'react-icons/bs';
import moment from 'moment';

import { useFetchReporte } from '../../hooks/useFetchReporte';

import Default from '../../contenedores/Default';

import CabeceroReportes from '../../componentes/CabeceroReportes';
import ListaConfiguracion from '../../componentes/ListaConfiguracion';
import ListaImagenes from '../../componentes/ListaImagenes';
import Modal from '../../componentes/Modal';
import Tabla from '../../componentes/Table';

import endpoints, { CAPTURA_SANEOS, SANEOS, TABLAS } from '../../configuraciones/endpoints';
import axios from '../../configuraciones/axios';

import { DatePickerTypes } from '../../constantes/datePickerTypes';
import { mapaDependenciasCompacto } from '../../constantes/reportes';

import styles from './styles';

const datosLista = {
  labelProp: 'nombre',
  headerLista: 'Nombre',
  title: 'Reporte de Saneos Realizados',
  data: [
    {
      id: 1,
      nombre: 'Saneos',
      subTitle: 'Listado por plagas',
    },
  ],
};

const ReporteSaneos = ({ history }) => {
  const classes = styles();

  const { registros } = useSelector((store) => store.listados);
  const { data, formData, buscar, onChange, onDelete } = useFetchReporte(
    {
      tablas: endpoints.base.busqueda(TABLAS),
      surcos: ([_sitios, _invernaderos, _naves, tablas]) =>
        tablas.map(({ surcos = [] }) => surcos).flat(),
      saneos: endpoints.base.busqueda(SANEOS),
    },
    endpoints.reporteSaneos(),
    { incluirInvernaderos: false },
  );

  const [imagenes, setImagenes] = useState([]);
  const [open, setOpen] = useState(false);
  const [params, setParams] = useState({});

  const cabeceros = [
    { label: 'SITIO', key: 'sitio', align: 'left' },
    { label: 'INVERNADERO', key: 'invernadero', align: 'left' },
    { label: 'NAVE', key: 'nave', align: 'left' },
    { label: 'TABLA', key: 'tabla', align: 'left' },
    { label: 'SURCO', key: 'surco', align: 'left' },
    { label: 'SANEO', key: 'saneo', align: 'left' },
    { label: 'CANTIDAD', key: 'cantidad', align: 'left' },
    {
      label: 'EVIDENCIA',
      key: '',
      align: 'center',
      transform: (data) => {
        if (!data) return null;
        return (
          <Chip
            icon={<BsImageFill color="#FFFF" />}
            className={classes.imagenView}
            label={`Ver`}
            size="small"
            onClick={() => {
              handleClickOpen({
                naveID: data.naveID,
                surcoID: data.surcoID,
                fecha: data.fecha,
              });
            }}
          />
        );
      },
    },
  ];

  const handleTodosSelected = useCallback(() => {
    const { sitios, naves, tablas, surcos, saneos, fecha } = formData;
    const params = {
      sitios,
      naves,
      surcos,
      tablas,
      saneos,
      fecha: moment(fecha).format('W-GGGG'),
    };

    return params;
  }, [formData]);

  const handleClickOpen = (params) => {
    setParams(params);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubMenuClick = (id) => {
    if (id === 1) {
      history.push(`/reportes/saneos`);
    }
  };

  useEffect(() => {
    let itemImagenes = [];
    if (Object.keys(params).length > 0) {
      axios
        .get(endpoints.base.url(`${CAPTURA_SANEOS}/imagenes`), {
          params,
        })
        .then((plantasImagenesBD) => {
          itemImagenes = plantasImagenesBD.map((element, index) => {
            return {
              ...element,
              title: moment(element.fechaRegistro).format('LLLL'),
              author: '@scoutter',
              featured: true,
            };
          });

          setImagenes(itemImagenes);
        });
    }
  }, [params]);

  return (
    <Default
      mostrarLista={
        <ListaConfiguracion datosLista={datosLista} onClick={onSubMenuClick} initOpcion={0} />
      }
    >
      <CabeceroReportes
        data={data}
        formData={formData}
        buscar={buscar}
        onChange={onChange}
        onDelete={onDelete}
        handleTodosSelected={handleTodosSelected}
        selects={{
          sitio: { width: 4, show: true },
          invernaderoNave: { width: 4, show: true },
          tabla: { width: 4, show: true },
          surco: { width: 3, show: true },
          saneo: { width: 3, show: true },
          fecha: { width: 3, show: true, type: DatePickerTypes.week },
        }}
        endpoint={endpoints.reporteSaneos()}
        method="POST"
        mapaDependencias={mapaDependenciasCompacto}
      />
      <Tabla
        headers={cabeceros}
        rows={registros.rows.length > 0 ? registros.rows : []}
        count={registros.count}
        showActions={false}
      />
      <Modal open={open} handleClose={handleClose} titulo="Imágenes de Saneos">
        <ListaImagenes data={imagenes} />
      </Modal>
    </Default>
  );
};

export default ReporteSaneos;
